import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
var TextAlign = /* @__PURE__ */ ((TextAlign2) => {
  TextAlign2["left"] = "left";
  TextAlign2["center"] = "center";
  TextAlign2["right"] = "right";
  return TextAlign2;
})(TextAlign || {});
const TableCell = ({
  nowrap = false,
  textAlign = "left",
  dataLabel,
  children,
  className,
  testId,
  mode = ModeType.normal,
  ...rest
}) => {
  const tableCellClass = classNames(
    tableStyles["table__cell"],
    { [tableStyles["table__cell--compact"]]: mode === ModeType.compact },
    { [tableStyles["table__cell--nowrap"]]: nowrap },
    { [tableStyles["table__cell--center"]]: textAlign === "center" },
    { [tableStyles["table__cell--right"]]: textAlign === "right" },
    className
  );
  return /* @__PURE__ */ jsx("td", { className: tableCellClass, "data-label": dataLabel, "data-testid": testId, ...rest, children });
};
export {
  TableCell as T,
  TextAlign as a
};
//# sourceMappingURL=TableCell.js.map
